<template>
  <div>
    <template v-if="$attrs.vertical">
      <v-tabs
        v-bind="$attrs"
        v-on="$listeners"
        class="v-tab-navigation-vertical"
      >
        <v-tab
          v-for="(item, tabIndex) in items"
          :key="item.tab"
          :style="{ 'text-transform': textTransform }"
          class="justify-start"
          :data-testid="$attrs['data-testid'] ? $attrs['data-testid'] + tabIndex : `tab${tabIndex}`"
          @change="()=>{ tabChange(tabIndex) }"
        >
          <v-icon
            v-if="item.icon || iconsOnly"
            left
          >
            {{ item.icon }}
          </v-icon>
          <span
            v-if="!iconsOnly"
            v-html="item.tab"
          />
        </v-tab>
        <v-tab-item
          v-for="(item, i) in items"
          :key="item.tab"
          v-bind="$attrs"
        >
          <slot :name="'content'+ (item.id ? item.id : i + 1)">
            <v-card flat>
              <v-card-text v-html="item.content" />
            </v-card>
          </slot>
        </v-tab-item>
      </v-tabs>
    </template>
    <template v-else>
      <v-tabs
        v-bind="$attrs"
        v-on="$listeners"
        :next-icon="nextIcon"
        :prev-icon="prevIcon"
        :show-arrows="showArrows"
        class="v-tab-navigation"
      >
        <v-tab
          v-for="(item, tabIndex) in items"
          :key="item.tab"
          :style="{ 'text-transform': textTransform }"
          :data-testid="$attrs['data-testid'] ? $attrs['data-testid'] + tabIndex : `tab${tabIndex}`"
          @change="()=>{ tabChange(tabIndex) }"
        >
          <span
            v-if="!iconsOnly"
            v-html="item.tab"
          />
          <v-icon v-if="$attrs['icons-and-text'] || iconsOnly">
            {{ item.icon }}
          </v-icon>
        </v-tab>
      <v-tab-item
          v-for="(item, i) in items"
          :key="item.tab"
        >
          <slot :name="'content'+ (item.id ? item.id : i + 1)">
            <v-card>
              <v-card-text v-html="item.content" />
            </v-card>
          </slot>
        </v-tab-item>
        </v-tabs>
    </template>
  </div>
</template>

<script>
export default {
  name: 'TabNavigation',
  data() {
    return {
      tab: null
    }
  },
  methods:{
    tabChange(index){
      this.tab = index;
      this.$emit('tabChange',index)
    }
  },
  props: {
    iconsOnly: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => [],
    },
    textTransform: {
      type: String,
      default: 'uppercase'
    },
    nextIcon: {
      type: String,
      default: 'keyboard_arrow_right'   // override the default value '$next' in v-tabs
    },
    prevIcon: {
      type: String,
      default: 'keyboard_arrow_left'   // override the default value '$prev' in v-tabs
    },
    showArrows: {
      type: [Boolean, String],
      default: true   // override the default value 'undefined' in v-tabs
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';

.v-tab-navigation .v-slide-group__wrapper,
.v-tab-navigation .v-window__container {
  padding-left: 0 !important;
}

.v-tabs .v-tab {
  font-size: 14px;
  text-align: left;
  letter-spacing: 0.03em;
  &.v-tab--active {
    font-weight: bold;
  }
}

.theme--light.v-tabs .v-tab:focus::before {
  opacity: inherit;
  border: 4px solid $ads-dark-60 !important;
}

.theme--light.v-tabs .v-tab.v-tab--active:focus::before {
  opacity: inherit;
  border: 4px solid $ads-navy !important;
}

.theme--dark.v-tabs .v-tab:focus::before {
  opacity: inherit;
  border: 4px solid $ads-white !important;
}

.v-tab:before {
  background-color: inherit !important;
}

/* Custom 'outline' for OES applications, can refactor for other projects later */
.v-tab-navigation-vertical .v-tab.v-tab--active {
  box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);
  border-radius: 0px 50px 50px 0px;
}
</style>
